var _circle, _mask, _path, _path2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none",
  viewBox: "0 0 28 28"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 14,
  fill: "#302E28"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "path-2-inside-1_7105_20198",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M23.72 19.498a11.2 11.2 0 0 1-9.76 5.702 11.2 11.2 0 0 1-9.76-5.702c1.922-2.446 5.572-4.098 9.76-4.098s7.838 1.652 9.76 4.098",
  clipRule: "evenodd"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M23.72 19.498a11.2 11.2 0 0 1-9.76 5.702 11.2 11.2 0 0 1-9.76-5.702c1.922-2.446 5.572-4.098 9.76-4.098s7.838 1.652 9.76 4.098",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m23.72 19.498.87.492.33-.583-.414-.527zm-19.52 0-.786-.618-.414.527.33.583zm9.76 6.702c4.562 0 8.539-2.505 10.63-6.21l-1.741-.984a10.2 10.2 0 0 1-8.89 5.194zM3.33 19.99a12.2 12.2 0 0 0 10.63 6.21v-2c-3.812 0-7.138-2.091-8.89-5.193zm1.656.126c1.691-2.153 5.02-3.716 8.974-3.716v-2c-4.42 0-8.394 1.74-10.546 4.48zM13.96 16.4c3.954 0 7.282 1.563 8.973 3.716l1.573-1.236c-2.153-2.74-6.126-4.48-10.546-4.48z",
  mask: "url(#path-2-inside-1_7105_20198)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 8.75,
  r: 3.875,
  fill: "#fff",
  stroke: "#fff"
})));
export default SvgMobile;